// Instance
import AuthAPI from '@/app/apis/auth/auth-api.js';

// Endpoints
import { AUTH, AUTH_ENDPOINTS } from '@/app/apis/auth/_connection/auth-connection-api.js';

class AuthRegisterAPI extends AuthAPI {
    /**
     * @param {*} authDetails - Contains userData and petData during registration
     */
    async putAuthRegister(authDetails) {
      return AUTH.put(AUTH_ENDPOINTS.PUT_REGISTER, authDetails);
    }
}
  
export default new AuthRegisterAPI();
  